module.exports = __webpack_public_path__ + "static/media/industry_hover.5d428841.svg";